import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Experiences from './components/Experiences';
import Accommodations from './components/Accommodations';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BookingWidget from './components/BookingWidget';
import './index.css';

function App() {
  return (
    <Router>
      <div className="relative min-h-screen">
        <Navbar />
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <About />
              <Experiences />
              <Accommodations />
              <Gallery />
              <Contact />
            </>
          } />
        </Routes>
        <BookingWidget />
        <Footer />
      </div>
    </Router>
  );
}

export default App;